import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/userOrderEmail.ts
const userOrderEmailItemSchema = z.object({
	email: z.email(),
	lastUsedAt: z.coerce.date()
});
const listInputSchema = z.object({ limit: z.coerce.number().int().min(1).max(20).default(5) });
const userOrderEmailContract = oc.prefix("/user-order-email").tag("UserOrderEmail").router({ list: oc.route({
	summary: "List the authenticated user's recently used billing emails",
	description: "Returns distinct billing emails the user has supplied at onerway checkout, most-recent first. Used to prefill the email field on the checkout form. The same email may have been entered multiple times; only the latest occurrence per email is returned.",
	method: "GET",
	path: "/"
}).input(listInputSchema).output(z.array(userOrderEmailItemSchema)).errors({ UNAUTHORIZED: {
	status: 401,
	message: "Authentication required"
} }) });
//#endregion
export { userOrderEmailContract, userOrderEmailItemSchema };
